/**
 * Who created EduFadder — shown on the About page, the footer, the extension's
 * settings and welcome pages. Edit this file to change names, titles, or bios;
 * no page code needs to change.
 *
 * Sources for each fact (checked 2026-10-24):
 *  - Kozan: FSU faculty profile, annescollege.fsu.edu/faculty-staff/dr-kadir-kozan
 *    (title, department, college, PhD, research lines, ALPS group).
 *  - Mbanzabugabo: program, affiliation, background and research focus as provided
 *    by him; LinkedIn profile link provided by him.
 */
export interface Author {
  id: string;
  name: string;
  honorific?: string;
  role: string;
  affiliation: string;
  bio: string[];
  focus: string[];
  links: Array<{ label: string; href: string }>;
}

export const AUTHORS: Author[] = [
  {
    id: "kozan",
    name: "Kadir Kozan",
    honorific: "Dr.",
    role: "Assistant Professor, Instructional Systems & Learning Technologies",
    affiliation:
      "Department of Educational Psychology and Learning Systems, Anne Spencer Daves College of Education, Health, and Human Sciences, Florida State University",
    bio: [
      "Dr. Kozan studies how to enhance human learning and performance in formal, informal, and nonformal educational and professional settings. His research lines focus on optimizing cognitive load; strengthening teaching, cognitive, and social presence; and effective learning strategies in technology-enhanced learning and performance contexts.",
      "He also works on the “science of educational science” — improving the quality of educational research itself, including through big data — and leads the ALPS (Advanced Learning and Performance Systems) research group. He holds a PhD in Learning, Design and Technology from Purdue University.",
    ],
    focus: ["Cognitive load", "Teaching, cognitive & social presence", "Learning strategies", "Quality of educational research", "AI in instructional design"],
    links: [{ label: "FSU faculty profile", href: "https://annescollege.fsu.edu/faculty-staff/dr-kadir-kozan" }],
  },
  {
    id: "mbanzabugabo",
    name: "Jean Baptiste Mbanzabugabo",
    role: "Ph.D. Candidate, Instructional Systems & Learning Technologies",
    affiliation: "Department of Educational Psychology and Learning Systems, Florida State University",
    bio: [
      "Jean Baptiste researches AI-generated adaptive feedback, learning analytics, natural language processing for educational discourse, and computational mixed methods; his dissertation compares real-time and delayed AI feedback.",
      "Before his doctoral studies he worked in higher education in Rwanda as a computer science lecturer, dean, and director of ICT, at the University of Tourism, Technology and Business Studies and the University of Kigali.",
    ],
    focus: ["AI-generated feedback", "Learning analytics", "NLP for educational discourse", "Computational mixed methods"],
    links: [{ label: "LinkedIn", href: "https://www.linkedin.com/in/jean-baptiste-mbanzabugabo-946b50a4/" }],
  },
];

export const HOW_TO_CITE = (version: string): string =>
  `Kozan, K., & Mbanzabugabo, J. B. (2026). EduFadder (Version ${version}) [Browser extension and web application]. Florida State University. https://edufadder.bshub.us`;

/** One line for footers and the extension. */
export const CREDIT_LINE =
  "Created by Dr. Kadir Kozan and Jean Baptiste Mbanzabugabo, Instructional Systems & Learning Technologies, Florida State University.";
